/* eslint-disable import/prefer-default-export */
import type {
  GroupRuleInfo,
  FailedObjectInfo,
  RuleInfo
} from '@src/endpoints/services/intentMgr.service'
import { ReferenceTypeEnum } from '@src/endpoints/openapis/saas-cam-alerts/models'
import type { Summary } from '@src/endpoints/openapis/saas-cam-alerts/models'

export interface RuleItem extends GroupRuleInfo {
  query?: string
  autoIntentId?: string
}

export interface Rule {
  [key: string]: any
}
export interface FailedObject extends FailedObjectInfo {
  account?: string
  region?: string
  referenceType?: ReferenceTypeEnum
}
export interface RuleDetails extends RuleInfo {}

export const defaultState = {
  list: [] as RuleItem[],
  failedByRuleId: [] as Summary[],
  totalCount: 0,
  failedCount: 0,
  passedCount: 0,
  ruleDetails: {} as RuleDetails,
  failedObjects: [] as FailedObject[],
  title: '',
  pending: false
}

export type RuleState = typeof defaultState
